type Feature<T extends FeatureConfig> = boolean | T;

interface FeatureConfig {
  enabled: boolean;
}
interface AnalysisReviewFeatureConfig extends FeatureConfig {
  manager_review?: boolean;
}
export interface ILicenseFeatures {
  ai?: Feature<FeatureConfig>;
  second_opinion?: Feature<FeatureConfig>;
  export_workspace?: Feature<FeatureConfig>;
  analysis_review?: Feature<AnalysisReviewFeatureConfig>;
  acquisition_available?: Feature<FeatureConfig>;
  llm_chat?: Feature<FeatureConfig>;
  download_available?: Feature<FeatureConfig>;
}
export interface ILicenseInfo {
  name: 'Basic' | 'Genius' | 'Magic';
  maxStorage: number;
  maxWorkspaces: number;
  maxUsers: number;
  features: ILicenseFeatures;
  tiraspot?: boolean;
  language?: string;
  labeling?: ILicenseLabeling[];
}

export enum ILicenseLabeling {
  CE = 'ce',
  LEGACY = 'legacy',
  RUO = 'ruo',
}
